import React from 'react';
import './Header.css';

const Header = (props) => {
    return (
        <div>
            <header>
                <img src={props.logo} alt="" />
                <div className="header-text">
                    <h1>Create a Developers team to make the world more Beautiful. Who can help people and society by sharing their knowledge.</h1>
                    <h2>Budget is $ <span className='budget'>10,00,000</span></h2>
                </div>
            </header>
        </div>
    );
};

export default Header;